import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { JobsReducer } from "../reducers/JobsReducer";

const JobsContext = createContext({
	state: JobsReducer.getInitialState(),
	actions: JobsReducer.actions,
});

export const useJobsContext = () => useContext(JobsContext);

export const JobsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: JobsReducer.getInitialState(),
		reducers: JobsReducer.caseReducers,
	});

	return (
		<JobsContext.Provider value={{ state, actions }}>
			{children}
		</JobsContext.Provider>
	);
};
